module.exports = __webpack_public_path__ + "media/images/lamp/red-1b22a16542fdfd20e23efe1c0da68efe.png";